import { gql } from "@apollo/client";

export const ApproveIntervention = gql`
	mutation AproveIntervention($interventionId: String!, $type: String) {
		aproveIntervention(interventionId: $interventionId, type: $type) {
			_id
			status
		}
	}
`;
